import { render, staticRenderFns } from "./WineStockListModalStockActionButton.vue?vue&type=template&id=cc88c5fe"
import script from "./WineStockListModalStockActionButton.vue?vue&type=script&lang=js"
export * from "./WineStockListModalStockActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc88c5fe')) {
      api.createRecord('cc88c5fe', component.options)
    } else {
      api.reload('cc88c5fe', component.options)
    }
    module.hot.accept("./WineStockListModalStockActionButton.vue?vue&type=template&id=cc88c5fe", function () {
      api.rerender('cc88c5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineStockListModalStockActionButton.vue"
export default component.exports